import moment from 'moment'
import { toast } from 'react-toastify'
import CamionesRechazadosEnCalado from '../../../../../../models/calado/camiones_rechazados'
import { TABLA_CAMIONES_RECHAZADOS_EN_CALADO } from '../../../../../../config/tables'
import { getColumnasRechazadosEnCalado, COLUMNS_CAMIONES_RECHAZADOS_TO_PRINT } from './constantesCamionesRechazadosEnCalado'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable (fechaDesde, fechaHasta, rol = null) {
  return (dispatch) => {
    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    CamionesRechazadosEnCalado.consultaCamionesRechazadosEnCaladoPorFecha(fechaD, fechaH).then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, cartadeporte: d.cartaDePorteAutomotor }) })
      const fecha = (fechaD === fechaH) ? `del ${moment(fechaD).format('DD-MM-YYYY')}` : `entre ${moment(fechaD).format('DD-MM-YYYY')} y ${moment(fechaH).format('DD-MM-YYYY')}`
      const textRowCount = `Cantidad de camiones rechazados en calado ${fecha} :`

      const customToolbar = pdfCustomToolbarGenerator(
        'Listado de camiones rechazados en calado',
        data,
        COLUMNS_CAMIONES_RECHAZADOS_TO_PRINT,
        'landscape'
      )
      const columnas = getColumnasRechazadosEnCalado(rol)

      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: `Camiones rechazados en calado`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            filter: true,
            pagination: false,
            tableBodyMaxHeight: '450px',
            showRowCount: true,
            textRowCount
          }
        },
        id: TABLA_CAMIONES_RECHAZADOS_EN_CALADO
      })
    }
    toast.info('Operación realizada exitosamente.')
  }
}
